export default __webpack_public_path__ + "static/media/FWX4GM.058358cf.jpeg";